import { render, staticRenderFns } from "./ChangeGeo.vue?vue&type=template&id=50c5e2cf&"
import script from "./ChangeGeo.vue?vue&type=script&lang=js&"
export * from "./ChangeGeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports